import styled from 'styled-components';
import { Description } from '../../index.view';

const TaxField = styled(Description)`
  font-size: 12px;
`;

const TaxContainer = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 0;
  margin-left: 15px;
`;

export { TaxField, TaxContainer };
